import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    Input,
    Optional,
    Renderer2,
    Self,
    ViewChild,
} from "@angular/core";
import { NgControl } from "@angular/forms";
import { AttributePresenceInput } from "@spscommerce/ng-utils";

import { SpsFormControlComponent } from "../forms/sps-form-control.abstract.component";

@Component({
    selector: "sps-checkbox",
    templateUrl: "./sps-checkbox.component.html",
    providers: [{ provide: SpsFormControlComponent, useExisting: SpsCheckboxComponent }]
})
export class SpsCheckboxComponent extends SpsFormControlComponent<boolean> {
    static readonly displayName = "sps-checkbox";
    static readonly props = {
        label: "string",
        indeterminate: "boolean",
        inline: "boolean",
    };

    @Input() label: string;

    @Input() @AttributePresenceInput() indeterminate = false;

    @Input()
    @AttributePresenceInput()
    @HostBinding("class.sps-custom-control--inline")
    inline: boolean;

    @HostBinding("class.sps-custom-control") readonly spsCustomControlClass = true;
    @HostBinding("class.sps-custom-checkbox") readonly spsCustomCheckboxClass = true;

    @HostBinding("class.sps-custom-control--no-label") get noLabelClass() {
        return !this.label;
    }

    get checked(): boolean {
        return this.model;
    }
    set checked(newValue: boolean) {
        this.model = newValue;
    }

    @ViewChild("checkboxInput", { static: false }) inputElement: ElementRef;

    constructor(
        el: ElementRef,
        renderer: Renderer2,
        @Self()
        @Optional()
        ngControl: NgControl,
        protected _changeDetector: ChangeDetectorRef
    ) {
        super(el, renderer, ngControl);
    }

    _updateChecked(checked: boolean) {
        // In IE11 on clicking indeterminate checkbox it becomes uncheck
        // for parity with other browser we need to explicitly make it checked
        const checkExplicitly = this.indeterminate ? true : checked;
        this.checked = checkExplicitly;
        this.inputElement.nativeElement.focus();
    }
}
